import React from 'react';
import {faArrowToBottom} from '@fortawesome/pro-light-svg-icons';
import PropTypes from 'prop-types';
import ActionsHeader from '../../shared/containers/ActionsHeader';

export default function ReposicionesHeader(props) {
  const {
    onComprobarStock, onGenerarPedido, onGenerarCsv, proveedorMultiopticasSeleccionado, inIframe,
  } = props;
  const data = [
    {
      translationId: 'reposiciones.generar_pedido',
      text: 'Generar pedido',
      onClick: onGenerarPedido,
    },
    {
      translationId: 'reposiciones.comprobar_stock',
      text: 'Comprobar stock',
      onClick: onComprobarStock,
      visible: proveedorMultiopticasSeleccionado,
    },
    { icon: faArrowToBottom, position: 'right', onClick: onGenerarCsv },
  ];
  return <ActionsHeader top={0} offsetTop={64} sticky={!inIframe} data={data} />;
}
ReposicionesHeader.propTypes = {
  proveedorMultiopticasSeleccionado: PropTypes.bool.isRequired,
  onComprobarStock: PropTypes.func.isRequired,
  onGenerarPedido: PropTypes.func.isRequired,
  onGenerarCsv: PropTypes.func.isRequired,
};
